import React, { useContext, useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";
import { ThemeContext } from "../../../state/ThemeContext";

const PressureAltitudeChartConsole = ({ value, color, sensor }) => {
  const theme = useContext(ThemeContext).theme;

  const [Altitudes, setAltitudesValues] = useState([]);
  const [Pressures, setPressuresValues] = useState([]);

  useEffect(() => {
    sensor === "pressure"
      ? setPressuresValues((prevPressures) => [...prevPressures, value])
      : setAltitudesValues((prevAltitudes) => [...prevAltitudes, value]);
  }, [value, sensor]);
  const options = {
    chart: {
      id: "realtime",
      height: 350,
      type: "line",
      animations: {
        enabled: true,
        easing: "linear",
        dynamicAnimation: {
          speed: 1000,
        },
      },
      foreColor: theme === "dark" ? "#ffffff" : "#000000",
      toolbar: {
        show: false,
      },
      zoom: {
        enabled: false,
      },
    },
    dataLabels: {
      enabled: false,
    },
    xaxis: {
      categories:
        sensor === "pressure"
          ? Pressures.map((_, index) => index + 1)
          : Altitudes.map((_, index) => index + 1),
    },
    yaxis: {
      labels: {
        formatter: function (value) {
          return parseInt(value).toString();
        },
      },
    },
    legend: {
      show: false,
    },
    colors: [color],
  };

  return (
    <div
      className={`spline-area-chart rounded-[12px] shadow-md  bg-white dark:bg-dark2 p-[15px]`}
    >
      <div className="flex justify-between">
        <div className="flex items-center gap-3">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
          >
            <g clipPath="url(#clip0_1205_20386)">
              <path
                d="M11.5773 10.3453H2.83465C2.73477 10.3455 2.63592 10.3252 2.54423 10.2856C2.45253 10.246 2.36996 10.188 2.30164 10.1151C2.23331 10.0423 2.1807 9.95617 2.14706 9.86213C2.11342 9.76809 2.09948 9.66814 2.10609 9.56848C2.12221 9.38082 2.2089 9.20625 2.34867 9.07999C2.48845 8.95374 2.67091 8.88519 2.85924 8.88819H10.8488C10.9487 8.88841 11.0475 8.86809 11.1392 8.8285C11.2309 8.7889 11.3135 8.73088 11.3818 8.65803C11.4501 8.58518 11.5027 8.49906 11.5364 8.40502C11.57 8.31098 11.584 8.21102 11.5773 8.11137C11.5612 7.9237 11.4745 7.74913 11.3348 7.62288C11.195 7.49662 11.0125 7.42808 10.8242 7.43107H9.0538C9.00117 7.43163 8.94905 7.42078 8.90102 7.39926C8.85299 7.37775 8.8102 7.34608 8.77558 7.30644C8.74096 7.2668 8.71534 7.22013 8.70048 7.16964C8.68563 7.11915 8.68189 7.06605 8.68952 7.01397C8.76945 6.46131 9.00647 5.94324 9.37239 5.52142C9.73832 5.0996 10.2177 4.7918 10.7536 4.63464C11.2894 4.47748 11.8591 4.47758 12.3949 4.63493C12.9307 4.79228 13.41 5.10026 13.7758 5.52221C14.1416 5.94415 14.3784 6.46231 14.4581 7.015C14.5379 7.5677 14.4571 8.13166 14.2255 8.63978C13.9939 9.1479 13.6212 9.57878 13.1517 9.88114C12.6822 10.1835 12.1358 10.3446 11.5773 10.3453ZM22.4984 10.1368C22.4471 9.41977 22.1327 8.74704 21.6155 8.24784C21.0983 7.74864 20.4148 7.4582 19.6965 7.43233C18.9781 7.40646 18.2756 7.64699 17.7238 8.1077C17.1721 8.5684 16.81 9.21677 16.7073 9.92821C16.6997 9.98028 16.7034 10.0334 16.7183 10.0839C16.7331 10.1344 16.7587 10.181 16.7934 10.2207C16.828 10.2603 16.8708 10.292 16.9188 10.3135C16.9668 10.335 17.019 10.3459 17.0716 10.3453H18.842C19.03 10.3428 19.212 10.4115 19.3514 10.5377C19.4908 10.6639 19.5772 10.8382 19.5933 11.0256C19.5999 11.1253 19.586 11.2252 19.5523 11.3192C19.5187 11.4133 19.4661 11.4994 19.3978 11.5723C19.3294 11.6451 19.2469 11.7031 19.1552 11.7427C19.0635 11.7823 18.9646 11.8026 18.8647 11.8024H3.5878C3.39947 11.7994 3.21701 11.868 3.07723 11.9942C2.93745 12.1205 2.85076 12.295 2.83465 12.4827C2.82803 12.5824 2.84198 12.6823 2.87562 12.7764C2.90926 12.8704 2.96187 12.9565 3.03019 13.0294C3.09852 13.1022 3.18109 13.1602 3.27278 13.1998C3.36448 13.2394 3.46333 13.2598 3.56321 13.2595H19.5915C19.9918 13.2596 20.3878 13.1771 20.7548 13.0174C21.1218 12.8576 21.452 12.6239 21.7247 12.3309C21.9975 12.038 22.2069 11.6919 22.34 11.3144C22.4732 10.9369 22.5271 10.536 22.4984 10.1368ZM14.4916 14.7167H4.31635C4.12802 14.7137 3.94556 14.7822 3.80579 14.9085C3.66601 15.0347 3.57932 15.2093 3.56321 15.3969C3.55659 15.4966 3.57054 15.5966 3.60417 15.6906C3.63781 15.7846 3.69043 15.8708 3.75875 15.9436C3.82708 16.0165 3.90965 16.0745 4.00134 16.1141C4.09303 16.1537 4.19189 16.174 4.29177 16.1738H13.7384C13.9264 16.1712 14.1084 16.24 14.2478 16.3662C14.3872 16.4924 14.4737 16.6667 14.4897 16.8541C14.4964 16.9537 14.4824 17.0537 14.4488 17.1477C14.4151 17.2417 14.3625 17.3279 14.2942 17.4007C14.2259 17.4736 14.1433 17.5316 14.0516 17.5712C13.9599 17.6108 13.8611 17.6311 13.7612 17.6309H11.968C11.9154 17.6303 11.8633 17.6412 11.8153 17.6627C11.7672 17.6842 11.7244 17.7159 11.6898 17.7555C11.6552 17.7952 11.6296 17.8418 11.6147 17.8923C11.5999 17.9428 11.5961 17.9959 11.6038 18.048C11.6837 18.6006 11.9207 19.1187 12.2866 19.5405C12.6525 19.9624 13.132 20.2702 13.6678 20.4273C14.2036 20.5845 14.7734 20.5844 15.3092 20.427C15.8449 20.2697 16.3242 19.9617 16.69 19.5398C17.0558 19.1178 17.2926 18.5996 17.3724 18.047C17.4521 17.4943 17.3713 16.9303 17.1397 16.4222C16.9081 15.9141 16.5354 15.4832 16.0659 15.1808C15.5964 14.8785 15.05 14.7173 14.4916 14.7167Z"
                fill={color}
              />
            </g>
            <defs>
              <clipPath id="clip0_1205_20386">
                <rect
                  width="23.3138"
                  height="23.3138"
                  fill="white"
                  transform="translate(0.648926 0.873901)"
                />
              </clipPath>
            </defs>
          </svg>
          <span className="text-[16px] font-[400] font-Roboto dark:text-white">
            {sensor === "pressure" ? "Pressure" : "Altitude"}
          </span>
        </div>
        <div className="flex items-baseline gap-1"></div>
      </div>
      {value && (
        <ReactApexChart
          options={options}
          series={[
            {
              data: sensor === "pressure" ? Pressures : Altitudes,
            },
          ]}
          type="line"
        />
      )}
    </div>
  );
};

export default PressureAltitudeChartConsole;
